import type { Experience } from '@axiom/validation';
import { DateUtil } from '@axiom/ui';

export const WarmingModalUtil = {
  getExperienceLabel: (experience: Experience) => {
    if (!experience.startDate && !experience.endDate) {
      return null;
    }
    const displayStartDate =
      DateUtil.displayLongMonthYear(experience.startDate) ?? 'Unknown';
    const displayEndDate = experience.endDate
      ? DateUtil.displayLongMonthYear(experience.endDate)
      : 'Present';

    return `${experience.client}; ${displayStartDate} - ${displayEndDate}`;
  },
};
